import { Skeleton } from 'antd';
import React from 'react';
import styled from 'styled-components';
import { CpWidgetVariantType } from 'api/customer-portal/types';
import { CpSectionWrapper } from 'components/organisms/customer-portal/widgets/common';
import { CpLoadingDesc, CpLoadingProps, CpLoadingTitle } from '../common';

const FormSkeleton = styled(Skeleton.Button)<{
  isBig?: boolean;
}>`
  .ant-skeleton,
  &.ant-skeleton {
    height: ${({ isBig }) => (isBig ? '220px' : '160px')};
    width: 100% !important;
  }

  .ant-skeleton-button {
    width: 100% !important;
    height: 100% !important;
  }
`;

const FormWrapper = styled.div`
  display: flex;
  gap: var(--cp-spacing-06);
  flex-direction: column;
  width: 100%;
  background: transparent;
  height: auto;
  margin-top: var(--cp-spacing-06);

  @media (max-width: 480px) {
    gap: var(--cp-spacing-05);
    flex-direction: column;
    margin-top: var(--cp-spacing-04);
  }
`;

const Form: React.FC<{
  variantType: CpWidgetVariantType;
}> = ({ variantType }) => {
  return (
    <FormSkeleton
      active
      shape="square"
      isBig={variantType === CpWidgetVariantType.MultiFormWithImageAtTheLeft}
    />
  );
};

export const CpProjectFormsLoading: React.FC<CpLoadingProps> = ({
  variantType,
  styles,
}) => {
  return (
    <CpSectionWrapper
      background={styles?.background as string}
      paddingY={styles?.paddingY as number | undefined}
      className="!cp-max-w-none"
    >
      <CpLoadingTitle active />
      <CpLoadingDesc active />

      <FormWrapper>
        <Form variantType={variantType} />
        <Form variantType={variantType} />
        <Form variantType={variantType} />
      </FormWrapper>
    </CpSectionWrapper>
  );
};
